export default [
  {
    path: "/comments",
    name: "comments",
    component: () => import("@/views/pages/comments/Comments.vue"),
    meta: {
      hasPermission:true,
      pageTitle: "سوالات کاربران",
      breadcrumb: [
        {
          text: "سوالات کاربران",
          active: true,
        },
      ],
    },
  },
];
